// When signing out, clear all Turbo cached snapshots so a subsequent login as
// a different user never sees the previous user's cached pages.
document.addEventListener("turbo:submit-start", function (event) {
  if (new URL(event.target.action, location.origin).pathname.endsWith("/sign_out")) {
    Turbo.clearCache();
  }
});

// On desktop (≥992px) the Jobs mega menu is shown via CSS hover. Bootstrap's
// click-triggered show adds Popper positioning and class changes that shift the
// menu. Cancel the show.bs.dropdown event so Bootstrap never touches the DOM —
// Bootstrap checks defaultPrevented before adding classes or calling Popper.
// On mobile Bootstrap handles everything normally.
document.addEventListener("turbo:load", function () {
  const toggle = document.getElementById("jobsDropdown");
  if (!toggle) return;

  toggle.addEventListener("show.bs.dropdown", function (e) {
    if (window.innerWidth >= 992) {
      e.preventDefault();
    }
  });
});
